/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
export const addressSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-common-subscription:Address',
    type: 'object',
    properties: {
        country: { type: 'string', minLength: 2 },
        state: { type: 'string', minLength: 2 },
        city: { type: 'string', minLength: 2 },
        postalCode: { type: 'string', minLength: 5 },
        line1: { type: 'string' },
        line2: { type: 'string' }
    },
    required: ['country', 'postalCode']
};
const func2 = ucs2length;
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:Address" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.country === undefined && (missing0 = 'country')) ||
                (data.postalCode === undefined && (missing0 = 'postalCode'))) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.country !== undefined) {
                    let data0 = data.country;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 2) {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/country',
                                        schemaPath: '#/properties/country/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 2 },
                                        message: 'must NOT have fewer than 2 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/country',
                                    schemaPath: '#/properties/country/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.state !== undefined) {
                        let data1 = data.state;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 2) {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/state',
                                            schemaPath: '#/properties/state/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 2 },
                                            message: 'must NOT have fewer than 2 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/state',
                                        schemaPath: '#/properties/state/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.city !== undefined) {
                            let data2 = data.city;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 2) {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/city',
                                                schemaPath: '#/properties/city/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 2 },
                                                message: 'must NOT have fewer than 2 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/city',
                                            schemaPath: '#/properties/city/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.postalCode !== undefined) {
                                let data3 = data.postalCode;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 5) {
                                            validate12.errors = [
                                                {
                                                    instancePath: instancePath + '/postalCode',
                                                    schemaPath: '#/properties/postalCode/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 5 },
                                                    message: 'must NOT have fewer than 5 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/postalCode',
                                                schemaPath: '#/properties/postalCode/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.line1 !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.line1 !== 'string') {
                                        validate12.errors = [
                                            {
                                                instancePath: instancePath + '/line1',
                                                schemaPath: '#/properties/line1/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.line2 !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.line2 !== 'string') {
                                            validate12.errors = [
                                                {
                                                    instancePath: instancePath + '/line2',
                                                    schemaPath: '#/properties/line2/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const initiateSubscriptionRequestSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-common-subscription:InitiateSubscriptionRequest',
    type: 'object',
    properties: { useTestClock: { type: 'boolean' } },
    required: ['useTestClock']
};
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:InitiateSubscriptionRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.useTestClock === undefined && (missing0 = 'useTestClock')) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.useTestClock !== undefined) {
                    if (typeof data.useTestClock !== 'boolean') {
                        validate13.errors = [
                            {
                                instancePath: instancePath + '/useTestClock',
                                schemaPath: '#/properties/useTestClock/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const newSubscriptionRequestSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-common-subscription:NewSubscriptionRequest',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        email: { type: 'string', minLength: 1 },
        billingAddress: { $ref: 'urn:wisepipe-common-subscription:Address' },
        shippingAddress: { $ref: 'urn:wisepipe-common-subscription:Address' },
        lookupKey: { type: 'string', minLength: 1 },
        quantity: { type: 'number' },
        paymentMethodID: { type: 'string', minLength: 6 }
    },
    required: ['lookupKey', 'quantity', 'paymentMethodID']
};
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:NewSubscriptionRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.lookupKey === undefined && (missing0 = 'lookupKey')) ||
                (data.quantity === undefined && (missing0 = 'quantity')) ||
                (data.paymentMethodID === undefined && (missing0 = 'paymentMethodID'))) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate14.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.email !== undefined) {
                        let data1 = data.email;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/email',
                                            schemaPath: '#/properties/email/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate14.errors = [
                                    {
                                        instancePath: instancePath + '/email',
                                        schemaPath: '#/properties/email/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.billingAddress !== undefined) {
                            let data2 = data.billingAddress;
                            const _errs5 = errors;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    let missing1;
                                    if ((data2.country === undefined && (missing1 = 'country')) ||
                                        (data2.postalCode === undefined && (missing1 = 'postalCode'))) {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/billingAddress',
                                                schemaPath: 'urn:wisepipe-common-subscription:Address/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing1 },
                                                message: "must have required property '" + missing1 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2.country !== undefined) {
                                            let data3 = data2.country;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 2) {
                                                        validate14.errors = [
                                                            {
                                                                instancePath: instancePath + '/billingAddress/country',
                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/country/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 2 },
                                                                message: 'must NOT have fewer than 2 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate14.errors = [
                                                        {
                                                            instancePath: instancePath + '/billingAddress/country',
                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/country/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data2.state !== undefined) {
                                                let data4 = data2.state;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 2) {
                                                            validate14.errors = [
                                                                {
                                                                    instancePath: instancePath + '/billingAddress/state',
                                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/state/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 2 },
                                                                    message: 'must NOT have fewer than 2 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate14.errors = [
                                                            {
                                                                instancePath: instancePath + '/billingAddress/state',
                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/state/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data2.city !== undefined) {
                                                    let data5 = data2.city;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 === 'string') {
                                                            if (func2(data5) < 2) {
                                                                validate14.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/billingAddress/city',
                                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/city/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 2 },
                                                                        message: 'must NOT have fewer than 2 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate14.errors = [
                                                                {
                                                                    instancePath: instancePath + '/billingAddress/city',
                                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/city/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data2.postalCode !== undefined) {
                                                        let data6 = data2.postalCode;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data6 === 'string') {
                                                                if (func2(data6) < 5) {
                                                                    validate14.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/billingAddress/postalCode',
                                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/postalCode/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 5 },
                                                                            message: 'must NOT have fewer than 5 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate14.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/billingAddress/postalCode',
                                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/postalCode/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data2.line1 !== undefined) {
                                                            const _errs16 = errors;
                                                            if (typeof data2.line1 !== 'string') {
                                                                validate14.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/billingAddress/line1',
                                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/line1/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid2 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (data2.line2 !== undefined) {
                                                                const _errs18 = errors;
                                                                if (typeof data2.line2 !== 'string') {
                                                                    validate14.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/billingAddress/line2',
                                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/line2/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid2 = _errs18 === errors;
                                                            }
                                                            else {
                                                                var valid2 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate14.errors = [
                                        {
                                            instancePath: instancePath + '/billingAddress',
                                            schemaPath: 'urn:wisepipe-common-subscription:Address/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.shippingAddress !== undefined) {
                                let data9 = data.shippingAddress;
                                const _errs20 = errors;
                                const _errs21 = errors;
                                if (errors === _errs21) {
                                    if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                                        let missing2;
                                        if ((data9.country === undefined && (missing2 = 'country')) ||
                                            (data9.postalCode === undefined && (missing2 = 'postalCode'))) {
                                            validate14.errors = [
                                                {
                                                    instancePath: instancePath + '/shippingAddress',
                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing2 },
                                                    message: "must have required property '" + missing2 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data9.country !== undefined) {
                                                let data10 = data9.country;
                                                const _errs23 = errors;
                                                if (errors === _errs23) {
                                                    if (typeof data10 === 'string') {
                                                        if (func2(data10) < 2) {
                                                            validate14.errors = [
                                                                {
                                                                    instancePath: instancePath + '/shippingAddress/country',
                                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/country/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 2 },
                                                                    message: 'must NOT have fewer than 2 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate14.errors = [
                                                            {
                                                                instancePath: instancePath + '/shippingAddress/country',
                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/country/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid4 = _errs23 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                            if (valid4) {
                                                if (data9.state !== undefined) {
                                                    let data11 = data9.state;
                                                    const _errs25 = errors;
                                                    if (errors === _errs25) {
                                                        if (typeof data11 === 'string') {
                                                            if (func2(data11) < 2) {
                                                                validate14.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/shippingAddress/state',
                                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/state/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 2 },
                                                                        message: 'must NOT have fewer than 2 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate14.errors = [
                                                                {
                                                                    instancePath: instancePath + '/shippingAddress/state',
                                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/state/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid4 = _errs25 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                                if (valid4) {
                                                    if (data9.city !== undefined) {
                                                        let data12 = data9.city;
                                                        const _errs27 = errors;
                                                        if (errors === _errs27) {
                                                            if (typeof data12 === 'string') {
                                                                if (func2(data12) < 2) {
                                                                    validate14.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/shippingAddress/city',
                                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/city/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 2 },
                                                                            message: 'must NOT have fewer than 2 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate14.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/shippingAddress/city',
                                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/city/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid4 = _errs27 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data9.postalCode !== undefined) {
                                                            let data13 = data9.postalCode;
                                                            const _errs29 = errors;
                                                            if (errors === _errs29) {
                                                                if (typeof data13 === 'string') {
                                                                    if (func2(data13) < 5) {
                                                                        validate14.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/shippingAddress/postalCode',
                                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/postalCode/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 5 },
                                                                                message: 'must NOT have fewer than 5 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate14.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/shippingAddress/postalCode',
                                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/postalCode/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid4 = _errs29 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data9.line1 !== undefined) {
                                                                const _errs31 = errors;
                                                                if (typeof data9.line1 !== 'string') {
                                                                    validate14.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/shippingAddress/line1',
                                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/line1/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid4 = _errs31 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                            if (valid4) {
                                                                if (data9.line2 !== undefined) {
                                                                    const _errs33 = errors;
                                                                    if (typeof data9.line2 !== 'string') {
                                                                        validate14.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/shippingAddress/line2',
                                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/line2/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid4 = _errs33 === errors;
                                                                }
                                                                else {
                                                                    var valid4 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate14.errors = [
                                            {
                                                instancePath: instancePath + '/shippingAddress',
                                                schemaPath: 'urn:wisepipe-common-subscription:Address/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs20 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.lookupKey !== undefined) {
                                    let data16 = data.lookupKey;
                                    const _errs35 = errors;
                                    if (errors === _errs35) {
                                        if (typeof data16 === 'string') {
                                            if (func2(data16) < 1) {
                                                validate14.errors = [
                                                    {
                                                        instancePath: instancePath + '/lookupKey',
                                                        schemaPath: '#/properties/lookupKey/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate14.errors = [
                                                {
                                                    instancePath: instancePath + '/lookupKey',
                                                    schemaPath: '#/properties/lookupKey/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs35 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.quantity !== undefined) {
                                        const _errs37 = errors;
                                        if (!(typeof data.quantity == 'number')) {
                                            validate14.errors = [
                                                {
                                                    instancePath: instancePath + '/quantity',
                                                    schemaPath: '#/properties/quantity/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs37 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.paymentMethodID !== undefined) {
                                            let data18 = data.paymentMethodID;
                                            const _errs39 = errors;
                                            if (errors === _errs39) {
                                                if (typeof data18 === 'string') {
                                                    if (func2(data18) < 6) {
                                                        validate14.errors = [
                                                            {
                                                                instancePath: instancePath + '/paymentMethodID',
                                                                schemaPath: '#/properties/paymentMethodID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 6 },
                                                                message: 'must NOT have fewer than 6 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate14.errors = [
                                                        {
                                                            instancePath: instancePath + '/paymentMethodID',
                                                            schemaPath: '#/properties/paymentMethodID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs39 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const orgWithCustomerIdSchemaValidation = validate15;
const schema34 = {
    $id: 'urn:wisepipe-common-subscription:OrgWithCustomerId',
    type: 'object',
    properties: { customerID: { type: 'string', minLength: 5 }, testClockID: { type: 'string', minLength: 5 } },
    required: ['customerID']
};
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:OrgWithCustomerId" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.customerID === undefined && (missing0 = 'customerID')) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.customerID !== undefined) {
                    let data0 = data.customerID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 5) {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/customerID',
                                        schemaPath: '#/properties/customerID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 5 },
                                        message: 'must NOT have fewer than 5 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate15.errors = [
                                {
                                    instancePath: instancePath + '/customerID',
                                    schemaPath: '#/properties/customerID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.testClockID !== undefined) {
                        let data1 = data.testClockID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 5) {
                                    validate15.errors = [
                                        {
                                            instancePath: instancePath + '/testClockID',
                                            schemaPath: '#/properties/testClockID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 5 },
                                            message: 'must NOT have fewer than 5 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate15.errors = [
                                    {
                                        instancePath: instancePath + '/testClockID',
                                        schemaPath: '#/properties/testClockID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const productSubscriptionSchemaValidation = validate16;
const schema35 = {
    $id: 'urn:wisepipe-common-subscription:ProductSubscription',
    type: 'object',
    properties: { type: { type: 'string' } },
    required: ['type']
};
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:ProductSubscription" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.type === undefined && (missing0 = 'type')) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    if (typeof data.type !== 'string') {
                        validate16.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const provisionSubscriptionEventSchemaValidation = validate17;
const schema36 = {
    $id: 'urn:wisepipe-common-subscription:ProvisionSubscriptionEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        quantity: { type: 'number', minimum: 0 },
        productCodes: {
            type: 'array',
            items: {
                type: 'string',
                enum: [
                    'basic_professional_subscription',
                    'connector.tqp',
                    'connector.icm',
                    'blueprint.fuzzy_matcher',
                    'blueprint.smart_matcher',
                    'blueprint.combination_matcher',
                    'blueprint.hierarchy_creation',
                    'blueprint.hierarchy_validator',
                    'blueprint.forecasting',
                    'blueprint.order_consolidation',
                    'blueprint.roster_validation',
                    'blueprint.recordID_and_adjustment',
                    'blueprint.identify_new_hires',
                    'blueprint.track_territory_changes',
                    'blueprint.transaction_reconciliation',
                    'blueprint.transaction_validation',
                    'blueprint.entity_resolution',
                    'blueprint.payout_outliers',
                    'blueprint.manual_adjustment_outliers',
                    'blueprint.seller_valuer_outliers',
                    'blueprint.asc_606_preparation',
                    'blueprint.asc_606_amortization',
                    'blueprint.transaction_outliers',
                    'blueprint.opportunity_scores',
                    'blueprint.deal_value_changes',
                    'blueprint.discounting_diagnostics',
                    'blueprint.lead_scoring',
                    'blueprint.customer_lifetime_value',
                    'blueprint.seller_capacity',
                    'blueprint.financial_advisor_turnover',
                    'app.sales_benchmarking',
                    'app.gender_pay',
                    'app.diversity',
                    'app.customer_churn',
                    'app.seller_churn',
                    'app.seller_performance',
                    'tool.gender_classifier',
                    'tool.smart_matcher',
                    'tool.classifier',
                    'tool.regressor',
                    'tool.forecast',
                    'tool.predictor',
                    'tool.aggregate',
                    'tool.aggregate_v2',
                    'tool.binning',
                    'tool.percentile',
                    'tool.rank',
                    'tool.sort',
                    'tool.adapt',
                    'tool.case',
                    'tool.change_type',
                    'tool.conditional',
                    'tool.unique',
                    'tool.drop',
                    'tool.fill',
                    'tool.filter',
                    'tool.limit',
                    'tool.remove_outliers',
                    'tool.remove_empty',
                    'tool.rename',
                    'tool.reorder',
                    'tool.select',
                    'tool.hierarchy_validator',
                    'tool.hierarchy_validator_v2',
                    'tool.clean_character',
                    'tool.split_columns',
                    'tool.table',
                    'tool.histogram',
                    'tool.line',
                    'tool.smooth_line',
                    'tool.step_line',
                    'tool.area_line',
                    'tool.area_smooth_line',
                    'tool.area_step_line',
                    'tool.stacked_area_line',
                    'tool.stacked_area_smooth_line',
                    'tool.stacked_area_step_line',
                    'tool.combo',
                    'tool.column',
                    'tool.stacked_column',
                    'tool.bar',
                    'tool.stacked_bar',
                    'tool.pie',
                    'tool.doughnut',
                    'tool.scatter',
                    'tool.bubble',
                    'tool.bubble_single_axis',
                    'tool.map',
                    'tool.scatter_map',
                    'tool.waterfall',
                    'tool.radar',
                    'tool.candlestick',
                    'tool.forecasting',
                    'tool.sankey',
                    'tool.heatmap',
                    'tool.boxplot',
                    'tool.nested_pie',
                    'tool.date_add',
                    'tool.date_diff',
                    'tool.date_part',
                    'tool.date_aggregate',
                    'tool.date_format',
                    'tool.amortization',
                    'tool.confusion_matrix',
                    'tool.multi_formula',
                    'tool.lag',
                    'tool.min_max_scaler',
                    'tool.most_common',
                    'tool.oversample',
                    'tool.running_average',
                    'tool.running_total',
                    'tool.sample',
                    'tool.standard_scaler',
                    'tool.undersample',
                    'tool.weighted_average',
                    'tool.category_encoder',
                    'tool.one_hot_encoder',
                    'tool.change_case',
                    'tool.extract',
                    'tool.merge_columns',
                    'tool.replace',
                    'tool.multi_replace',
                    'tool.select_word',
                    'tool.text_between',
                    'tool.text_length',
                    'tool.text_part',
                    'tool.text_sentiment',
                    'tool.trim',
                    'tool.trim_tags',
                    'tool.text_classifiers',
                    'tool.word_frequency',
                    'tool.combination_matcher',
                    'tool.fuzzy_matcher',
                    'tool.join',
                    'tool.join_v2',
                    'tool.record_id',
                    'tool.repeat',
                    'tool.reshape',
                    'tool.reshape_v2',
                    'tool.snapshot',
                    'tool.split',
                    'tool.text_grade_level',
                    'tool.union',
                    'tool.multi_union',
                    'tool.hierarchy',
                    'tool.hierarchy_v2',
                    'tool.lookup',
                    'tool.segmentation',
                    'tool.outlier',
                    'tool.data',
                    'tool.pipe',
                    'tool.multi_port_pipe',
                    'tool.export',
                    'tool.us_income',
                    'tool.us_population',
                    'tool.assignment_optimization',
                    'tool.monte_carlo',
                    'tool.random_number_generator',
                    'tool.sample_customers',
                    'tool.period_mapper',
                    'tool.rule_mapper',
                    'tool.rule_mapper_v2',
                    'tool.incentives_export',
                    'tool.incentives_import',
                    'tool.incentives_table',
                    'tool.incentives_period',
                    'tool.user_defined_calc',
                    'tool.sort_calc',
                    'tool.time_shift_calc',
                    'tool.category_calc',
                    'tool.true_up',
                    'tool.period_add',
                    'tool.period_diff',
                    'tool.expand_picklist',
                    'tool.period_accumulation',
                    'tool.reusable_logic',
                    'tool.reusable_logic_input',
                    'tool.reusable_logic_output'
                ]
            }
        }
    },
    required: ['orgID', 'orgPlan', 'quantity', 'productCodes']
};
const formats0 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:ProvisionSubscriptionEvent" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.orgPlan === undefined && (missing0 = 'orgPlan')) ||
                (data.quantity === undefined && (missing0 = 'quantity')) ||
                (data.productCodes === undefined && (missing0 = 'productCodes'))) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.test(data0)) {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgPlan !== undefined) {
                        let data1 = data.orgPlan;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'Social' ||
                            data1 === 'Enterprise' ||
                            data1 === 'Integration' ||
                            data1 === 'Temp' ||
                            data1 === 'Starter' ||
                            data1 === 'Professional')) {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/orgPlan',
                                    schemaPath: '#/properties/orgPlan/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema36.properties.orgPlan.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.quantity !== undefined) {
                            let data2 = data.quantity;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 == 'number') {
                                    if (data2 < 0 || isNaN(data2)) {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/quantity',
                                                schemaPath: '#/properties/quantity/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/quantity',
                                            schemaPath: '#/properties/quantity/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.productCodes !== undefined) {
                                let data3 = data.productCodes;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (Array.isArray(data3)) {
                                        var valid1 = true;
                                        const len0 = data3.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data4 = data3[i0];
                                            const _errs9 = errors;
                                            if (typeof data4 !== 'string') {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/productCodes/' + i0,
                                                        schemaPath: '#/properties/productCodes/items/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data4 === 'basic_professional_subscription' ||
                                                data4 === 'connector.tqp' ||
                                                data4 === 'connector.icm' ||
                                                data4 === 'blueprint.fuzzy_matcher' ||
                                                data4 === 'blueprint.smart_matcher' ||
                                                data4 === 'blueprint.combination_matcher' ||
                                                data4 === 'blueprint.hierarchy_creation' ||
                                                data4 === 'blueprint.hierarchy_validator' ||
                                                data4 === 'blueprint.forecasting' ||
                                                data4 === 'blueprint.order_consolidation' ||
                                                data4 === 'blueprint.roster_validation' ||
                                                data4 === 'blueprint.recordID_and_adjustment' ||
                                                data4 === 'blueprint.identify_new_hires' ||
                                                data4 === 'blueprint.track_territory_changes' ||
                                                data4 === 'blueprint.transaction_reconciliation' ||
                                                data4 === 'blueprint.transaction_validation' ||
                                                data4 === 'blueprint.entity_resolution' ||
                                                data4 === 'blueprint.payout_outliers' ||
                                                data4 === 'blueprint.manual_adjustment_outliers' ||
                                                data4 === 'blueprint.seller_valuer_outliers' ||
                                                data4 === 'blueprint.asc_606_preparation' ||
                                                data4 === 'blueprint.asc_606_amortization' ||
                                                data4 === 'blueprint.transaction_outliers' ||
                                                data4 === 'blueprint.opportunity_scores' ||
                                                data4 === 'blueprint.deal_value_changes' ||
                                                data4 === 'blueprint.discounting_diagnostics' ||
                                                data4 === 'blueprint.lead_scoring' ||
                                                data4 === 'blueprint.customer_lifetime_value' ||
                                                data4 === 'blueprint.seller_capacity' ||
                                                data4 === 'blueprint.financial_advisor_turnover' ||
                                                data4 === 'app.sales_benchmarking' ||
                                                data4 === 'app.gender_pay' ||
                                                data4 === 'app.diversity' ||
                                                data4 === 'app.customer_churn' ||
                                                data4 === 'app.seller_churn' ||
                                                data4 === 'app.seller_performance' ||
                                                data4 === 'tool.gender_classifier' ||
                                                data4 === 'tool.smart_matcher' ||
                                                data4 === 'tool.classifier' ||
                                                data4 === 'tool.regressor' ||
                                                data4 === 'tool.forecast' ||
                                                data4 === 'tool.predictor' ||
                                                data4 === 'tool.aggregate' ||
                                                data4 === 'tool.aggregate_v2' ||
                                                data4 === 'tool.binning' ||
                                                data4 === 'tool.percentile' ||
                                                data4 === 'tool.rank' ||
                                                data4 === 'tool.sort' ||
                                                data4 === 'tool.adapt' ||
                                                data4 === 'tool.case' ||
                                                data4 === 'tool.change_type' ||
                                                data4 === 'tool.conditional' ||
                                                data4 === 'tool.unique' ||
                                                data4 === 'tool.drop' ||
                                                data4 === 'tool.fill' ||
                                                data4 === 'tool.filter' ||
                                                data4 === 'tool.limit' ||
                                                data4 === 'tool.remove_outliers' ||
                                                data4 === 'tool.remove_empty' ||
                                                data4 === 'tool.rename' ||
                                                data4 === 'tool.reorder' ||
                                                data4 === 'tool.select' ||
                                                data4 === 'tool.hierarchy_validator' ||
                                                data4 === 'tool.hierarchy_validator_v2' ||
                                                data4 === 'tool.clean_character' ||
                                                data4 === 'tool.split_columns' ||
                                                data4 === 'tool.table' ||
                                                data4 === 'tool.histogram' ||
                                                data4 === 'tool.line' ||
                                                data4 === 'tool.smooth_line' ||
                                                data4 === 'tool.step_line' ||
                                                data4 === 'tool.area_line' ||
                                                data4 === 'tool.area_smooth_line' ||
                                                data4 === 'tool.area_step_line' ||
                                                data4 === 'tool.stacked_area_line' ||
                                                data4 === 'tool.stacked_area_smooth_line' ||
                                                data4 === 'tool.stacked_area_step_line' ||
                                                data4 === 'tool.combo' ||
                                                data4 === 'tool.column' ||
                                                data4 === 'tool.stacked_column' ||
                                                data4 === 'tool.bar' ||
                                                data4 === 'tool.stacked_bar' ||
                                                data4 === 'tool.pie' ||
                                                data4 === 'tool.doughnut' ||
                                                data4 === 'tool.scatter' ||
                                                data4 === 'tool.bubble' ||
                                                data4 === 'tool.bubble_single_axis' ||
                                                data4 === 'tool.map' ||
                                                data4 === 'tool.scatter_map' ||
                                                data4 === 'tool.waterfall' ||
                                                data4 === 'tool.radar' ||
                                                data4 === 'tool.candlestick' ||
                                                data4 === 'tool.forecasting' ||
                                                data4 === 'tool.sankey' ||
                                                data4 === 'tool.heatmap' ||
                                                data4 === 'tool.boxplot' ||
                                                data4 === 'tool.nested_pie' ||
                                                data4 === 'tool.date_add' ||
                                                data4 === 'tool.date_diff' ||
                                                data4 === 'tool.date_part' ||
                                                data4 === 'tool.date_aggregate' ||
                                                data4 === 'tool.date_format' ||
                                                data4 === 'tool.amortization' ||
                                                data4 === 'tool.confusion_matrix' ||
                                                data4 === 'tool.multi_formula' ||
                                                data4 === 'tool.lag' ||
                                                data4 === 'tool.min_max_scaler' ||
                                                data4 === 'tool.most_common' ||
                                                data4 === 'tool.oversample' ||
                                                data4 === 'tool.running_average' ||
                                                data4 === 'tool.running_total' ||
                                                data4 === 'tool.sample' ||
                                                data4 === 'tool.standard_scaler' ||
                                                data4 === 'tool.undersample' ||
                                                data4 === 'tool.weighted_average' ||
                                                data4 === 'tool.category_encoder' ||
                                                data4 === 'tool.one_hot_encoder' ||
                                                data4 === 'tool.change_case' ||
                                                data4 === 'tool.extract' ||
                                                data4 === 'tool.merge_columns' ||
                                                data4 === 'tool.replace' ||
                                                data4 === 'tool.multi_replace' ||
                                                data4 === 'tool.select_word' ||
                                                data4 === 'tool.text_between' ||
                                                data4 === 'tool.text_length' ||
                                                data4 === 'tool.text_part' ||
                                                data4 === 'tool.text_sentiment' ||
                                                data4 === 'tool.trim' ||
                                                data4 === 'tool.trim_tags' ||
                                                data4 === 'tool.text_classifiers' ||
                                                data4 === 'tool.word_frequency' ||
                                                data4 === 'tool.combination_matcher' ||
                                                data4 === 'tool.fuzzy_matcher' ||
                                                data4 === 'tool.join' ||
                                                data4 === 'tool.join_v2' ||
                                                data4 === 'tool.record_id' ||
                                                data4 === 'tool.repeat' ||
                                                data4 === 'tool.reshape' ||
                                                data4 === 'tool.reshape_v2' ||
                                                data4 === 'tool.snapshot' ||
                                                data4 === 'tool.split' ||
                                                data4 === 'tool.text_grade_level' ||
                                                data4 === 'tool.union' ||
                                                data4 === 'tool.multi_union' ||
                                                data4 === 'tool.hierarchy' ||
                                                data4 === 'tool.hierarchy_v2' ||
                                                data4 === 'tool.lookup' ||
                                                data4 === 'tool.segmentation' ||
                                                data4 === 'tool.outlier' ||
                                                data4 === 'tool.data' ||
                                                data4 === 'tool.pipe' ||
                                                data4 === 'tool.multi_port_pipe' ||
                                                data4 === 'tool.export' ||
                                                data4 === 'tool.us_income' ||
                                                data4 === 'tool.us_population' ||
                                                data4 === 'tool.assignment_optimization' ||
                                                data4 === 'tool.monte_carlo' ||
                                                data4 === 'tool.random_number_generator' ||
                                                data4 === 'tool.sample_customers' ||
                                                data4 === 'tool.period_mapper' ||
                                                data4 === 'tool.rule_mapper' ||
                                                data4 === 'tool.rule_mapper_v2' ||
                                                data4 === 'tool.incentives_export' ||
                                                data4 === 'tool.incentives_import' ||
                                                data4 === 'tool.incentives_table' ||
                                                data4 === 'tool.incentives_period' ||
                                                data4 === 'tool.user_defined_calc' ||
                                                data4 === 'tool.sort_calc' ||
                                                data4 === 'tool.time_shift_calc' ||
                                                data4 === 'tool.category_calc' ||
                                                data4 === 'tool.true_up' ||
                                                data4 === 'tool.period_add' ||
                                                data4 === 'tool.period_diff' ||
                                                data4 === 'tool.expand_picklist' ||
                                                data4 === 'tool.period_accumulation' ||
                                                data4 === 'tool.reusable_logic' ||
                                                data4 === 'tool.reusable_logic_input' ||
                                                data4 === 'tool.reusable_logic_output')) {
                                                validate17.errors = [
                                                    {
                                                        instancePath: instancePath + '/productCodes/' + i0,
                                                        schemaPath: '#/properties/productCodes/items/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema36.properties.productCodes.items.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid1 = _errs9 === errors;
                                            if (!valid1) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate17.errors = [
                                            {
                                                instancePath: instancePath + '/productCodes',
                                                schemaPath: '#/properties/productCodes/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const stripeManagementUrlsSchemaValidation = validate18;
const schema37 = {
    $id: 'urn:wisepipe-common-subscription:StripeManagementUrls',
    type: 'object',
    properties: { portalUrl: { type: 'string' }, invoicesUrl: { type: 'string' } },
    required: ['portalUrl', 'invoicesUrl']
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:StripeManagementUrls" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.portalUrl === undefined && (missing0 = 'portalUrl')) ||
                (data.invoicesUrl === undefined && (missing0 = 'invoicesUrl'))) {
                validate18.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.portalUrl !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.portalUrl !== 'string') {
                        validate18.errors = [
                            {
                                instancePath: instancePath + '/portalUrl',
                                schemaPath: '#/properties/portalUrl/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.invoicesUrl !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.invoicesUrl !== 'string') {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/invoicesUrl',
                                    schemaPath: '#/properties/invoicesUrl/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const stripeSubscriptionSchemaValidation = validate19;
const schema38 = {
    $id: 'urn:wisepipe-common-subscription:StripeSubscription',
    type: 'object',
    properties: { lastPaidAt: { type: 'string', format: 'date-time' } },
    required: ['initiatorUserID', 'orgPlan', 'quantity', 'status']
};
const formats2 = formatWrapper['date-time'];
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:StripeSubscription" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.initiatorUserID === undefined && (missing0 = 'initiatorUserID')) ||
                (data.orgPlan === undefined && (missing0 = 'orgPlan')) ||
                (data.quantity === undefined && (missing0 = 'quantity')) ||
                (data.status === undefined && (missing0 = 'status'))) {
                validate19.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lastPaidAt !== undefined) {
                    let data0 = data.lastPaidAt;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats2.validate(data0)) {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/lastPaidAt',
                                            schemaPath: '#/properties/lastPaidAt/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/lastPaidAt',
                                        schemaPath: '#/properties/lastPaidAt/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate19.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const subscriptionEstimationResponseSchemaValidation = validate20;
const schema39 = {
    $id: 'urn:wisepipe-common-subscription:SubscriptionEstimationResponse',
    type: 'object',
    properties: {
        validatedBillingAddress: { $ref: 'urn:wisepipe-common-subscription:Address' },
        validatedShippingAddress: { $ref: 'urn:wisepipe-common-subscription:Address' },
        estimationResult: {
            type: 'string',
            enum: ['ok', 'addressResolutionFailure', 'taxResolutionFailure', 'otherFailure']
        },
        subscriptionAmount: { type: 'number', minimum: 0 },
        taxRate: { type: 'number', minimum: 0 },
        taxAmount: { type: 'number', minimum: 0 },
        messages: { type: 'array', items: { type: 'string', minLength: 1 } }
    },
    required: ['estimationResult', 'subscriptionAmount', 'taxRate', 'taxAmount']
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:SubscriptionEstimationResponse" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.estimationResult === undefined && (missing0 = 'estimationResult')) ||
                (data.subscriptionAmount === undefined && (missing0 = 'subscriptionAmount')) ||
                (data.taxRate === undefined && (missing0 = 'taxRate')) ||
                (data.taxAmount === undefined && (missing0 = 'taxAmount'))) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.validatedBillingAddress !== undefined) {
                    let data0 = data.validatedBillingAddress;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.country === undefined && (missing1 = 'country')) ||
                                (data0.postalCode === undefined && (missing1 = 'postalCode'))) {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/validatedBillingAddress',
                                        schemaPath: 'urn:wisepipe-common-subscription:Address/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.country !== undefined) {
                                    let data1 = data0.country;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 2) {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/validatedBillingAddress/country',
                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/country/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 2 },
                                                        message: 'must NOT have fewer than 2 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate20.errors = [
                                                {
                                                    instancePath: instancePath + '/validatedBillingAddress/country',
                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/country/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.state !== undefined) {
                                        let data2 = data0.state;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 2) {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/validatedBillingAddress/state',
                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/state/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 2 },
                                                            message: 'must NOT have fewer than 2 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/validatedBillingAddress/state',
                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/state/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data0.city !== undefined) {
                                            let data3 = data0.city;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 2) {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/validatedBillingAddress/city',
                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/city/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 2 },
                                                                message: 'must NOT have fewer than 2 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/validatedBillingAddress/city',
                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/city/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data0.postalCode !== undefined) {
                                                let data4 = data0.postalCode;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 5) {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/validatedBillingAddress/postalCode',
                                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/postalCode/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 5 },
                                                                    message: 'must NOT have fewer than 5 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/validatedBillingAddress/postalCode',
                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/postalCode/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data0.line1 !== undefined) {
                                                    const _errs12 = errors;
                                                    if (typeof data0.line1 !== 'string') {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/validatedBillingAddress/line1',
                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/line1/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data0.line2 !== undefined) {
                                                        const _errs14 = errors;
                                                        if (typeof data0.line2 !== 'string') {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/validatedBillingAddress/line2',
                                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/line2/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate20.errors = [
                                {
                                    instancePath: instancePath + '/validatedBillingAddress',
                                    schemaPath: 'urn:wisepipe-common-subscription:Address/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.validatedShippingAddress !== undefined) {
                        let data7 = data.validatedShippingAddress;
                        const _errs16 = errors;
                        const _errs17 = errors;
                        if (errors === _errs17) {
                            if (data7 && typeof data7 == 'object' && !Array.isArray(data7)) {
                                let missing2;
                                if ((data7.country === undefined && (missing2 = 'country')) ||
                                    (data7.postalCode === undefined && (missing2 = 'postalCode'))) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/validatedShippingAddress',
                                            schemaPath: 'urn:wisepipe-common-subscription:Address/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data7.country !== undefined) {
                                        let data8 = data7.country;
                                        const _errs19 = errors;
                                        if (errors === _errs19) {
                                            if (typeof data8 === 'string') {
                                                if (func2(data8) < 2) {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/validatedShippingAddress/country',
                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/country/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 2 },
                                                            message: 'must NOT have fewer than 2 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/validatedShippingAddress/country',
                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/country/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid4 = _errs19 === errors;
                                    }
                                    else {
                                        var valid4 = true;
                                    }
                                    if (valid4) {
                                        if (data7.state !== undefined) {
                                            let data9 = data7.state;
                                            const _errs21 = errors;
                                            if (errors === _errs21) {
                                                if (typeof data9 === 'string') {
                                                    if (func2(data9) < 2) {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/validatedShippingAddress/state',
                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/state/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 2 },
                                                                message: 'must NOT have fewer than 2 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/validatedShippingAddress/state',
                                                            schemaPath: 'urn:wisepipe-common-subscription:Address/properties/state/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid4 = _errs21 === errors;
                                        }
                                        else {
                                            var valid4 = true;
                                        }
                                        if (valid4) {
                                            if (data7.city !== undefined) {
                                                let data10 = data7.city;
                                                const _errs23 = errors;
                                                if (errors === _errs23) {
                                                    if (typeof data10 === 'string') {
                                                        if (func2(data10) < 2) {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/validatedShippingAddress/city',
                                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/city/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 2 },
                                                                    message: 'must NOT have fewer than 2 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/validatedShippingAddress/city',
                                                                schemaPath: 'urn:wisepipe-common-subscription:Address/properties/city/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid4 = _errs23 === errors;
                                            }
                                            else {
                                                var valid4 = true;
                                            }
                                            if (valid4) {
                                                if (data7.postalCode !== undefined) {
                                                    let data11 = data7.postalCode;
                                                    const _errs25 = errors;
                                                    if (errors === _errs25) {
                                                        if (typeof data11 === 'string') {
                                                            if (func2(data11) < 5) {
                                                                validate20.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/validatedShippingAddress/postalCode',
                                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/postalCode/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 5 },
                                                                        message: 'must NOT have fewer than 5 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/validatedShippingAddress/postalCode',
                                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/postalCode/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid4 = _errs25 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                                if (valid4) {
                                                    if (data7.line1 !== undefined) {
                                                        const _errs27 = errors;
                                                        if (typeof data7.line1 !== 'string') {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/validatedShippingAddress/line1',
                                                                    schemaPath: 'urn:wisepipe-common-subscription:Address/properties/line1/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid4 = _errs27 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data7.line2 !== undefined) {
                                                            const _errs29 = errors;
                                                            if (typeof data7.line2 !== 'string') {
                                                                validate20.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/validatedShippingAddress/line2',
                                                                        schemaPath: 'urn:wisepipe-common-subscription:Address/properties/line2/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid4 = _errs29 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/validatedShippingAddress',
                                        schemaPath: 'urn:wisepipe-common-subscription:Address/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs16 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.estimationResult !== undefined) {
                            let data14 = data.estimationResult;
                            const _errs31 = errors;
                            if (typeof data14 !== 'string') {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/estimationResult',
                                        schemaPath: '#/properties/estimationResult/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data14 === 'ok' ||
                                data14 === 'addressResolutionFailure' ||
                                data14 === 'taxResolutionFailure' ||
                                data14 === 'otherFailure')) {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/estimationResult',
                                        schemaPath: '#/properties/estimationResult/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema39.properties.estimationResult.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs31 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.subscriptionAmount !== undefined) {
                                let data15 = data.subscriptionAmount;
                                const _errs33 = errors;
                                if (errors === _errs33) {
                                    if (typeof data15 == 'number') {
                                        if (data15 < 0 || isNaN(data15)) {
                                            validate20.errors = [
                                                {
                                                    instancePath: instancePath + '/subscriptionAmount',
                                                    schemaPath: '#/properties/subscriptionAmount/minimum',
                                                    keyword: 'minimum',
                                                    params: { comparison: '>=', limit: 0 },
                                                    message: 'must be >= 0'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/subscriptionAmount',
                                                schemaPath: '#/properties/subscriptionAmount/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs33 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.taxRate !== undefined) {
                                    let data16 = data.taxRate;
                                    const _errs35 = errors;
                                    if (errors === _errs35) {
                                        if (typeof data16 == 'number') {
                                            if (data16 < 0 || isNaN(data16)) {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/taxRate',
                                                        schemaPath: '#/properties/taxRate/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 0 },
                                                        message: 'must be >= 0'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate20.errors = [
                                                {
                                                    instancePath: instancePath + '/taxRate',
                                                    schemaPath: '#/properties/taxRate/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs35 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.taxAmount !== undefined) {
                                        let data17 = data.taxAmount;
                                        const _errs37 = errors;
                                        if (errors === _errs37) {
                                            if (typeof data17 == 'number') {
                                                if (data17 < 0 || isNaN(data17)) {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/taxAmount',
                                                            schemaPath: '#/properties/taxAmount/minimum',
                                                            keyword: 'minimum',
                                                            params: { comparison: '>=', limit: 0 },
                                                            message: 'must be >= 0'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/taxAmount',
                                                        schemaPath: '#/properties/taxAmount/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs37 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.messages !== undefined) {
                                            let data18 = data.messages;
                                            const _errs39 = errors;
                                            if (errors === _errs39) {
                                                if (Array.isArray(data18)) {
                                                    var valid5 = true;
                                                    const len0 = data18.length;
                                                    for (let i0 = 0; i0 < len0; i0++) {
                                                        let data19 = data18[i0];
                                                        const _errs41 = errors;
                                                        if (errors === _errs41) {
                                                            if (typeof data19 === 'string') {
                                                                if (func2(data19) < 1) {
                                                                    validate20.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/messages/' + i0,
                                                                            schemaPath: '#/properties/messages/items/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate20.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/messages/' + i0,
                                                                        schemaPath: '#/properties/messages/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid5 = _errs41 === errors;
                                                        if (!valid5) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/messages',
                                                            schemaPath: '#/properties/messages/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs39 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate20.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
export const subscriptionSchemaValidation = validate21;
const schema42 = {
    $id: 'urn:wisepipe-common-subscription:Subscription',
    type: 'object',
    properties: {
        subscriptionID: { type: 'string', minLength: 5 },
        orgID: { type: 'string', format: 'uuid' },
        initiatorUserID: { type: 'string', minLength: 1, maxLength: 128 },
        orgPlan: { type: 'string', enum: ['Social', 'Enterprise', 'Integration', 'Temp', 'Starter', 'Professional'] },
        quantity: { type: 'number', minimum: 0 },
        status: { type: 'string', enum: ['draft', 'draftTaxApplied', 'active', 'expired', 'cancelled'] },
        subscriptionOwnerSystem: { type: 'string', enum: ['stripe', 'symon', 'product'] },
        productCodes: {
            type: 'array',
            items: {
                type: 'string',
                enum: [
                    'basic_professional_subscription',
                    'connector.tqp',
                    'connector.icm',
                    'blueprint.fuzzy_matcher',
                    'blueprint.smart_matcher',
                    'blueprint.combination_matcher',
                    'blueprint.hierarchy_creation',
                    'blueprint.hierarchy_validator',
                    'blueprint.forecasting',
                    'blueprint.order_consolidation',
                    'blueprint.roster_validation',
                    'blueprint.recordID_and_adjustment',
                    'blueprint.identify_new_hires',
                    'blueprint.track_territory_changes',
                    'blueprint.transaction_reconciliation',
                    'blueprint.transaction_validation',
                    'blueprint.entity_resolution',
                    'blueprint.payout_outliers',
                    'blueprint.manual_adjustment_outliers',
                    'blueprint.seller_valuer_outliers',
                    'blueprint.asc_606_preparation',
                    'blueprint.asc_606_amortization',
                    'blueprint.transaction_outliers',
                    'blueprint.opportunity_scores',
                    'blueprint.deal_value_changes',
                    'blueprint.discounting_diagnostics',
                    'blueprint.lead_scoring',
                    'blueprint.customer_lifetime_value',
                    'blueprint.seller_capacity',
                    'blueprint.financial_advisor_turnover',
                    'app.sales_benchmarking',
                    'app.gender_pay',
                    'app.diversity',
                    'app.customer_churn',
                    'app.seller_churn',
                    'app.seller_performance',
                    'tool.gender_classifier',
                    'tool.smart_matcher',
                    'tool.classifier',
                    'tool.regressor',
                    'tool.forecast',
                    'tool.predictor',
                    'tool.aggregate',
                    'tool.aggregate_v2',
                    'tool.binning',
                    'tool.percentile',
                    'tool.rank',
                    'tool.sort',
                    'tool.adapt',
                    'tool.case',
                    'tool.change_type',
                    'tool.conditional',
                    'tool.unique',
                    'tool.drop',
                    'tool.fill',
                    'tool.filter',
                    'tool.limit',
                    'tool.remove_outliers',
                    'tool.remove_empty',
                    'tool.rename',
                    'tool.reorder',
                    'tool.select',
                    'tool.hierarchy_validator',
                    'tool.hierarchy_validator_v2',
                    'tool.clean_character',
                    'tool.split_columns',
                    'tool.table',
                    'tool.histogram',
                    'tool.line',
                    'tool.smooth_line',
                    'tool.step_line',
                    'tool.area_line',
                    'tool.area_smooth_line',
                    'tool.area_step_line',
                    'tool.stacked_area_line',
                    'tool.stacked_area_smooth_line',
                    'tool.stacked_area_step_line',
                    'tool.combo',
                    'tool.column',
                    'tool.stacked_column',
                    'tool.bar',
                    'tool.stacked_bar',
                    'tool.pie',
                    'tool.doughnut',
                    'tool.scatter',
                    'tool.bubble',
                    'tool.bubble_single_axis',
                    'tool.map',
                    'tool.scatter_map',
                    'tool.waterfall',
                    'tool.radar',
                    'tool.candlestick',
                    'tool.forecasting',
                    'tool.sankey',
                    'tool.heatmap',
                    'tool.boxplot',
                    'tool.nested_pie',
                    'tool.date_add',
                    'tool.date_diff',
                    'tool.date_part',
                    'tool.date_aggregate',
                    'tool.date_format',
                    'tool.amortization',
                    'tool.confusion_matrix',
                    'tool.multi_formula',
                    'tool.lag',
                    'tool.min_max_scaler',
                    'tool.most_common',
                    'tool.oversample',
                    'tool.running_average',
                    'tool.running_total',
                    'tool.sample',
                    'tool.standard_scaler',
                    'tool.undersample',
                    'tool.weighted_average',
                    'tool.category_encoder',
                    'tool.one_hot_encoder',
                    'tool.change_case',
                    'tool.extract',
                    'tool.merge_columns',
                    'tool.replace',
                    'tool.multi_replace',
                    'tool.select_word',
                    'tool.text_between',
                    'tool.text_length',
                    'tool.text_part',
                    'tool.text_sentiment',
                    'tool.trim',
                    'tool.trim_tags',
                    'tool.text_classifiers',
                    'tool.word_frequency',
                    'tool.combination_matcher',
                    'tool.fuzzy_matcher',
                    'tool.join',
                    'tool.join_v2',
                    'tool.record_id',
                    'tool.repeat',
                    'tool.reshape',
                    'tool.reshape_v2',
                    'tool.snapshot',
                    'tool.split',
                    'tool.text_grade_level',
                    'tool.union',
                    'tool.multi_union',
                    'tool.hierarchy',
                    'tool.hierarchy_v2',
                    'tool.lookup',
                    'tool.segmentation',
                    'tool.outlier',
                    'tool.data',
                    'tool.pipe',
                    'tool.multi_port_pipe',
                    'tool.export',
                    'tool.us_income',
                    'tool.us_population',
                    'tool.assignment_optimization',
                    'tool.monte_carlo',
                    'tool.random_number_generator',
                    'tool.sample_customers',
                    'tool.period_mapper',
                    'tool.rule_mapper',
                    'tool.rule_mapper_v2',
                    'tool.incentives_export',
                    'tool.incentives_import',
                    'tool.incentives_table',
                    'tool.incentives_period',
                    'tool.user_defined_calc',
                    'tool.sort_calc',
                    'tool.time_shift_calc',
                    'tool.category_calc',
                    'tool.true_up',
                    'tool.period_add',
                    'tool.period_diff',
                    'tool.expand_picklist',
                    'tool.period_accumulation',
                    'tool.reusable_logic',
                    'tool.reusable_logic_input',
                    'tool.reusable_logic_output'
                ]
            }
        },
        flags: { type: 'array', items: { type: 'string', enum: ['paymentFailed', 'subscriptionCancelled'] } },
        createdAt: { type: 'string', format: 'date-time' },
        renewsAt: { type: 'string', format: 'date-time' }
    },
    required: ['subscriptionID', 'orgID', 'subscriptionOwnerSystem', 'createdAt']
};
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:Subscription" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.subscriptionID === undefined && (missing0 = 'subscriptionID')) ||
                (data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.subscriptionOwnerSystem === undefined && (missing0 = 'subscriptionOwnerSystem')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt'))) {
                validate21.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.subscriptionID !== undefined) {
                    let data0 = data.subscriptionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 5) {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/subscriptionID',
                                        schemaPath: '#/properties/subscriptionID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 5 },
                                        message: 'must NOT have fewer than 5 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate21.errors = [
                                {
                                    instancePath: instancePath + '/subscriptionID',
                                    schemaPath: '#/properties/subscriptionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.orgID !== undefined) {
                        let data1 = data.orgID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0.test(data1)) {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/orgID',
                                                schemaPath: '#/properties/orgID/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.initiatorUserID !== undefined) {
                            let data2 = data.initiatorUserID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 128) {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/initiatorUserID',
                                                schemaPath: '#/properties/initiatorUserID/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 128 },
                                                message: 'must NOT have more than 128 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/initiatorUserID',
                                                    schemaPath: '#/properties/initiatorUserID/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/initiatorUserID',
                                            schemaPath: '#/properties/initiatorUserID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.orgPlan !== undefined) {
                                let data3 = data.orgPlan;
                                const _errs7 = errors;
                                if (typeof data3 !== 'string') {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data3 === 'Social' ||
                                    data3 === 'Enterprise' ||
                                    data3 === 'Integration' ||
                                    data3 === 'Temp' ||
                                    data3 === 'Starter' ||
                                    data3 === 'Professional')) {
                                    validate21.errors = [
                                        {
                                            instancePath: instancePath + '/orgPlan',
                                            schemaPath: '#/properties/orgPlan/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema42.properties.orgPlan.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.quantity !== undefined) {
                                    let data4 = data.quantity;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 == 'number') {
                                            if (data4 < 0 || isNaN(data4)) {
                                                validate21.errors = [
                                                    {
                                                        instancePath: instancePath + '/quantity',
                                                        schemaPath: '#/properties/quantity/minimum',
                                                        keyword: 'minimum',
                                                        params: { comparison: '>=', limit: 0 },
                                                        message: 'must be >= 0'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/quantity',
                                                    schemaPath: '#/properties/quantity/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.status !== undefined) {
                                        let data5 = data.status;
                                        const _errs11 = errors;
                                        if (typeof data5 !== 'string') {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/status',
                                                    schemaPath: '#/properties/status/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data5 === 'draft' ||
                                            data5 === 'draftTaxApplied' ||
                                            data5 === 'active' ||
                                            data5 === 'expired' ||
                                            data5 === 'cancelled')) {
                                            validate21.errors = [
                                                {
                                                    instancePath: instancePath + '/status',
                                                    schemaPath: '#/properties/status/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema42.properties.status.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.subscriptionOwnerSystem !== undefined) {
                                            let data6 = data.subscriptionOwnerSystem;
                                            const _errs13 = errors;
                                            if (typeof data6 !== 'string') {
                                                validate21.errors = [
                                                    {
                                                        instancePath: instancePath + '/subscriptionOwnerSystem',
                                                        schemaPath: '#/properties/subscriptionOwnerSystem/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data6 === 'stripe' || data6 === 'symon' || data6 === 'product')) {
                                                validate21.errors = [
                                                    {
                                                        instancePath: instancePath + '/subscriptionOwnerSystem',
                                                        schemaPath: '#/properties/subscriptionOwnerSystem/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema42.properties.subscriptionOwnerSystem.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.productCodes !== undefined) {
                                                let data7 = data.productCodes;
                                                const _errs15 = errors;
                                                if (errors === _errs15) {
                                                    if (Array.isArray(data7)) {
                                                        var valid1 = true;
                                                        const len0 = data7.length;
                                                        for (let i0 = 0; i0 < len0; i0++) {
                                                            let data8 = data7[i0];
                                                            const _errs17 = errors;
                                                            if (typeof data8 !== 'string') {
                                                                validate21.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/productCodes/' + i0,
                                                                        schemaPath: '#/properties/productCodes/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            if (!(data8 === 'basic_professional_subscription' ||
                                                                data8 === 'connector.tqp' ||
                                                                data8 === 'connector.icm' ||
                                                                data8 === 'blueprint.fuzzy_matcher' ||
                                                                data8 === 'blueprint.smart_matcher' ||
                                                                data8 === 'blueprint.combination_matcher' ||
                                                                data8 === 'blueprint.hierarchy_creation' ||
                                                                data8 === 'blueprint.hierarchy_validator' ||
                                                                data8 === 'blueprint.forecasting' ||
                                                                data8 === 'blueprint.order_consolidation' ||
                                                                data8 === 'blueprint.roster_validation' ||
                                                                data8 === 'blueprint.recordID_and_adjustment' ||
                                                                data8 === 'blueprint.identify_new_hires' ||
                                                                data8 === 'blueprint.track_territory_changes' ||
                                                                data8 === 'blueprint.transaction_reconciliation' ||
                                                                data8 === 'blueprint.transaction_validation' ||
                                                                data8 === 'blueprint.entity_resolution' ||
                                                                data8 === 'blueprint.payout_outliers' ||
                                                                data8 === 'blueprint.manual_adjustment_outliers' ||
                                                                data8 === 'blueprint.seller_valuer_outliers' ||
                                                                data8 === 'blueprint.asc_606_preparation' ||
                                                                data8 === 'blueprint.asc_606_amortization' ||
                                                                data8 === 'blueprint.transaction_outliers' ||
                                                                data8 === 'blueprint.opportunity_scores' ||
                                                                data8 === 'blueprint.deal_value_changes' ||
                                                                data8 === 'blueprint.discounting_diagnostics' ||
                                                                data8 === 'blueprint.lead_scoring' ||
                                                                data8 === 'blueprint.customer_lifetime_value' ||
                                                                data8 === 'blueprint.seller_capacity' ||
                                                                data8 === 'blueprint.financial_advisor_turnover' ||
                                                                data8 === 'app.sales_benchmarking' ||
                                                                data8 === 'app.gender_pay' ||
                                                                data8 === 'app.diversity' ||
                                                                data8 === 'app.customer_churn' ||
                                                                data8 === 'app.seller_churn' ||
                                                                data8 === 'app.seller_performance' ||
                                                                data8 === 'tool.gender_classifier' ||
                                                                data8 === 'tool.smart_matcher' ||
                                                                data8 === 'tool.classifier' ||
                                                                data8 === 'tool.regressor' ||
                                                                data8 === 'tool.forecast' ||
                                                                data8 === 'tool.predictor' ||
                                                                data8 === 'tool.aggregate' ||
                                                                data8 === 'tool.aggregate_v2' ||
                                                                data8 === 'tool.binning' ||
                                                                data8 === 'tool.percentile' ||
                                                                data8 === 'tool.rank' ||
                                                                data8 === 'tool.sort' ||
                                                                data8 === 'tool.adapt' ||
                                                                data8 === 'tool.case' ||
                                                                data8 === 'tool.change_type' ||
                                                                data8 === 'tool.conditional' ||
                                                                data8 === 'tool.unique' ||
                                                                data8 === 'tool.drop' ||
                                                                data8 === 'tool.fill' ||
                                                                data8 === 'tool.filter' ||
                                                                data8 === 'tool.limit' ||
                                                                data8 === 'tool.remove_outliers' ||
                                                                data8 === 'tool.remove_empty' ||
                                                                data8 === 'tool.rename' ||
                                                                data8 === 'tool.reorder' ||
                                                                data8 === 'tool.select' ||
                                                                data8 === 'tool.hierarchy_validator' ||
                                                                data8 === 'tool.hierarchy_validator_v2' ||
                                                                data8 === 'tool.clean_character' ||
                                                                data8 === 'tool.split_columns' ||
                                                                data8 === 'tool.table' ||
                                                                data8 === 'tool.histogram' ||
                                                                data8 === 'tool.line' ||
                                                                data8 === 'tool.smooth_line' ||
                                                                data8 === 'tool.step_line' ||
                                                                data8 === 'tool.area_line' ||
                                                                data8 === 'tool.area_smooth_line' ||
                                                                data8 === 'tool.area_step_line' ||
                                                                data8 === 'tool.stacked_area_line' ||
                                                                data8 === 'tool.stacked_area_smooth_line' ||
                                                                data8 === 'tool.stacked_area_step_line' ||
                                                                data8 === 'tool.combo' ||
                                                                data8 === 'tool.column' ||
                                                                data8 === 'tool.stacked_column' ||
                                                                data8 === 'tool.bar' ||
                                                                data8 === 'tool.stacked_bar' ||
                                                                data8 === 'tool.pie' ||
                                                                data8 === 'tool.doughnut' ||
                                                                data8 === 'tool.scatter' ||
                                                                data8 === 'tool.bubble' ||
                                                                data8 === 'tool.bubble_single_axis' ||
                                                                data8 === 'tool.map' ||
                                                                data8 === 'tool.scatter_map' ||
                                                                data8 === 'tool.waterfall' ||
                                                                data8 === 'tool.radar' ||
                                                                data8 === 'tool.candlestick' ||
                                                                data8 === 'tool.forecasting' ||
                                                                data8 === 'tool.sankey' ||
                                                                data8 === 'tool.heatmap' ||
                                                                data8 === 'tool.boxplot' ||
                                                                data8 === 'tool.nested_pie' ||
                                                                data8 === 'tool.date_add' ||
                                                                data8 === 'tool.date_diff' ||
                                                                data8 === 'tool.date_part' ||
                                                                data8 === 'tool.date_aggregate' ||
                                                                data8 === 'tool.date_format' ||
                                                                data8 === 'tool.amortization' ||
                                                                data8 === 'tool.confusion_matrix' ||
                                                                data8 === 'tool.multi_formula' ||
                                                                data8 === 'tool.lag' ||
                                                                data8 === 'tool.min_max_scaler' ||
                                                                data8 === 'tool.most_common' ||
                                                                data8 === 'tool.oversample' ||
                                                                data8 === 'tool.running_average' ||
                                                                data8 === 'tool.running_total' ||
                                                                data8 === 'tool.sample' ||
                                                                data8 === 'tool.standard_scaler' ||
                                                                data8 === 'tool.undersample' ||
                                                                data8 === 'tool.weighted_average' ||
                                                                data8 === 'tool.category_encoder' ||
                                                                data8 === 'tool.one_hot_encoder' ||
                                                                data8 === 'tool.change_case' ||
                                                                data8 === 'tool.extract' ||
                                                                data8 === 'tool.merge_columns' ||
                                                                data8 === 'tool.replace' ||
                                                                data8 === 'tool.multi_replace' ||
                                                                data8 === 'tool.select_word' ||
                                                                data8 === 'tool.text_between' ||
                                                                data8 === 'tool.text_length' ||
                                                                data8 === 'tool.text_part' ||
                                                                data8 === 'tool.text_sentiment' ||
                                                                data8 === 'tool.trim' ||
                                                                data8 === 'tool.trim_tags' ||
                                                                data8 === 'tool.text_classifiers' ||
                                                                data8 === 'tool.word_frequency' ||
                                                                data8 === 'tool.combination_matcher' ||
                                                                data8 === 'tool.fuzzy_matcher' ||
                                                                data8 === 'tool.join' ||
                                                                data8 === 'tool.join_v2' ||
                                                                data8 === 'tool.record_id' ||
                                                                data8 === 'tool.repeat' ||
                                                                data8 === 'tool.reshape' ||
                                                                data8 === 'tool.reshape_v2' ||
                                                                data8 === 'tool.snapshot' ||
                                                                data8 === 'tool.split' ||
                                                                data8 === 'tool.text_grade_level' ||
                                                                data8 === 'tool.union' ||
                                                                data8 === 'tool.multi_union' ||
                                                                data8 === 'tool.hierarchy' ||
                                                                data8 === 'tool.hierarchy_v2' ||
                                                                data8 === 'tool.lookup' ||
                                                                data8 === 'tool.segmentation' ||
                                                                data8 === 'tool.outlier' ||
                                                                data8 === 'tool.data' ||
                                                                data8 === 'tool.pipe' ||
                                                                data8 === 'tool.multi_port_pipe' ||
                                                                data8 === 'tool.export' ||
                                                                data8 === 'tool.us_income' ||
                                                                data8 === 'tool.us_population' ||
                                                                data8 === 'tool.assignment_optimization' ||
                                                                data8 === 'tool.monte_carlo' ||
                                                                data8 === 'tool.random_number_generator' ||
                                                                data8 === 'tool.sample_customers' ||
                                                                data8 === 'tool.period_mapper' ||
                                                                data8 === 'tool.rule_mapper' ||
                                                                data8 === 'tool.rule_mapper_v2' ||
                                                                data8 === 'tool.incentives_export' ||
                                                                data8 === 'tool.incentives_import' ||
                                                                data8 === 'tool.incentives_table' ||
                                                                data8 === 'tool.incentives_period' ||
                                                                data8 === 'tool.user_defined_calc' ||
                                                                data8 === 'tool.sort_calc' ||
                                                                data8 === 'tool.time_shift_calc' ||
                                                                data8 === 'tool.category_calc' ||
                                                                data8 === 'tool.true_up' ||
                                                                data8 === 'tool.period_add' ||
                                                                data8 === 'tool.period_diff' ||
                                                                data8 === 'tool.expand_picklist' ||
                                                                data8 === 'tool.period_accumulation' ||
                                                                data8 === 'tool.reusable_logic' ||
                                                                data8 === 'tool.reusable_logic_input' ||
                                                                data8 === 'tool.reusable_logic_output')) {
                                                                validate21.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/productCodes/' + i0,
                                                                        schemaPath: '#/properties/productCodes/items/enum',
                                                                        keyword: 'enum',
                                                                        params: { allowedValues: schema42.properties.productCodes.items.enum },
                                                                        message: 'must be equal to one of the allowed values'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid1 = _errs17 === errors;
                                                            if (!valid1) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate21.errors = [
                                                            {
                                                                instancePath: instancePath + '/productCodes',
                                                                schemaPath: '#/properties/productCodes/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.flags !== undefined) {
                                                    let data9 = data.flags;
                                                    const _errs19 = errors;
                                                    if (errors === _errs19) {
                                                        if (Array.isArray(data9)) {
                                                            var valid2 = true;
                                                            const len1 = data9.length;
                                                            for (let i1 = 0; i1 < len1; i1++) {
                                                                let data10 = data9[i1];
                                                                const _errs21 = errors;
                                                                if (typeof data10 !== 'string') {
                                                                    validate21.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/flags/' + i1,
                                                                            schemaPath: '#/properties/flags/items/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                if (!(data10 === 'paymentFailed' || data10 === 'subscriptionCancelled')) {
                                                                    validate21.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/flags/' + i1,
                                                                            schemaPath: '#/properties/flags/items/enum',
                                                                            keyword: 'enum',
                                                                            params: { allowedValues: schema42.properties.flags.items.enum },
                                                                            message: 'must be equal to one of the allowed values'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid2 = _errs21 === errors;
                                                                if (!valid2) {
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate21.errors = [
                                                                {
                                                                    instancePath: instancePath + '/flags',
                                                                    schemaPath: '#/properties/flags/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'array' },
                                                                    message: 'must be array'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs19 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.createdAt !== undefined) {
                                                        let data11 = data.createdAt;
                                                        const _errs23 = errors;
                                                        if (errors === _errs23) {
                                                            if (errors === _errs23) {
                                                                if (typeof data11 === 'string') {
                                                                    if (!formats2.validate(data11)) {
                                                                        validate21.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/createdAt',
                                                                                schemaPath: '#/properties/createdAt/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate21.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/createdAt',
                                                                            schemaPath: '#/properties/createdAt/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid0 = _errs23 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.renewsAt !== undefined) {
                                                            let data12 = data.renewsAt;
                                                            const _errs25 = errors;
                                                            if (errors === _errs25) {
                                                                if (errors === _errs25) {
                                                                    if (typeof data12 === 'string') {
                                                                        if (!formats2.validate(data12)) {
                                                                            validate21.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/renewsAt',
                                                                                    schemaPath: '#/properties/renewsAt/format',
                                                                                    keyword: 'format',
                                                                                    params: { format: 'date-time' },
                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate21.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/renewsAt',
                                                                                schemaPath: '#/properties/renewsAt/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            var valid0 = _errs25 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate21.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const symonSubscriptionSchemaValidation = validate22;
const schema43 = {
    $id: 'urn:wisepipe-common-subscription:SymonSubscription',
    type: 'object',
    properties: {},
    required: ['initiatorUserID', 'orgPlan', 'quantity', 'status']
};
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-subscription:SymonSubscription" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.initiatorUserID === undefined && (missing0 = 'initiatorUserID')) ||
                (data.orgPlan === undefined && (missing0 = 'orgPlan')) ||
                (data.quantity === undefined && (missing0 = 'quantity')) ||
                (data.status === undefined && (missing0 = 'status'))) {
                validate22.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        else {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map